export const ADJUST_POINTS_TYPE = {
  ADD: 'add',
  DEDUCT: 'deduct'
};

export const ADD_POINTS_REASONS = [
  {
    value: 'Compensation-Delay',
    label: 'Compensation-Delay'
  },
  {
    value: 'Compensation-Cancellation',
    label: 'Compensation-Cancellation'
  },
  {
    value: 'Compensation-Air Con Issues',
    label: 'Compensation-Air Con Issues'
  },
  {
    value: 'Compensation - No Meal SP/BP',
    label: 'Compensation - No Meal SP/BP'
  },
  {
    value: 'Compensation - No Full Meal Service SP/BP',
    label: 'Compensation - No Full Meal Service SP/BP'
  },
  {
    value: 'Compensation - Detrainment',
    label: 'Compensation - Detrainment'
  },
  {
    value: 'Correction',
    label: 'Correction'
  },
  {
    value: 'Goodwill',
    label: 'Goodwill'
  },
  {
    value: 'Other',
    label: 'Other'
  }
];

export const DEDUCT_POINTS_REASONS = [
  { value: 'Correction', label: 'Correction' },
  {
    value: 'Red Lounge Access',
    label: 'Red Lounge Access'
  },
  { value: 'Other', label: 'Other' }
];

export const MAX_ADD_POINTS_AMOUNT = 10000;

export const PREFFERRED_LANGUAGE = [
  { key: 'EN', value: 'English' },
  { key: 'FR', value: 'French' },
  { key: 'NL', value: 'Dutch' }
];

export const BOOKINGS_SEARCH_TYPE = {
  ALL: 'ALL',
  PAST_BOOKINGS: 'PAST_BOOKINGS',
  UPCOMING_BOOKINGS: 'UPCOMING_BOOKINGS'
};

export const THALYS_PASS_TICKETS_CODES = ['TH_PUB_STD_TP', 'TH_PUB_PRE_TP', 'TH_PUB_COM_TP'];

export const VAT_NUMBER_KEY = 'vat_number';

export const CARRIER_CODE = {
  BLUE: 'BLUE',
  RED: 'RED'
};

export const mapCarrierCode = {
  [CARRIER_CODE.BLUE]: 'Blue',
  [CARRIER_CODE.RED]: 'Red'
};

export const NO_VAT_TTP = 'NOVAT';

export const LOYALTY_TIER_1 = 'Tier1';
export const LOYALTY_TIER_2 = 'Tier2';
export const LOYALTY_TIER_3 = 'Tier3';
export const LOYALTY_TIER_4 = 'Tier4';
export const LOYALTY_TIER_5 = 'Tier5';

export const MAX_NUMBER_OF_COMPANION_VOUCHER = 2;

export const LOYALTY_PROMO_PERIODS = [
  { start: '2024-02-06', end: '2024-02-16' },
  { start: '2025-05-06', end: '2025-05-15' },
  { start: '2026-03-10', end: '2026-03-19' }
];

export const LOYALTY_ACCOUNT_STATUS = {
  ACTIVE: 'Active',
  MERGED: 'Merged',
  INACTIVE: 'Inactive',
  SUSPENDED: 'Suspended'
};

export const POINTS_REDEMPTION_MISMATCH_KEY = 'POINTS_REDEMPTION_MISMATCH';
